import React, { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CloseSquareOutlined } from "@ant-design/icons";

export default function OrderCard({ modalId, onClose }) {
  // State variables to manage form submission status and form data
  const [loading, setLoading] = useState(false); // Tracks the loading state
  const [submitted, setSubmitted] = useState(false); // Tracks if form was successfully submitted
  const [formData, setFormData] = useState({
    name: "",
    tel: "",
    email: "",
    order: "",
  });

  // Handles form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handles form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevents page reload on form submit
    setLoading(true); // Set loading state to true when submitting

    // Simulate form submission delay (replace with actual submission logic)
    setTimeout(() => {
      setLoading(false); // Stop loading after "submission"
      setSubmitted(true); // Set submitted state to true
    }, 2000); // 2 seconds delay to mimic form submission
  };

  return (
    <Dialog open={true} onClose={onClose} className="relative">
      <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center mt-20">
          <DialogPanel className="relative transform overflow-hidden bg-cardColor z-10 text-left shadow-xl transition-all sm:my-8 sm:w-3/4 sm:max-w-lg">
            <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4 bg-cardColor">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="text-base font-semibold leading-6 text-gray-900"
                  >
                    <div className="flex mb-4">
                      {modalId === 1 && (
                        <h1 className="text-2xl">
                          Quick{" "}
                          <span style={{ color: "#557a82" }}>Website</span>
                        </h1>
                      )}
                      {modalId === 2 && (
                        <h1 className="text-2xl">
                          Quick{" "}
                          <span style={{ color: "#557a82" }}>Design</span>
                        </h1>
                      )}
                      {modalId === 3 && (
                        <h1 className="text-2xl">
                          Quick Registration to{" "}
                          <span style={{ color: "#557a82" }}>Training</span>
                        </h1>
                      )}
                      {modalId === 4 && (
                        <h1 className="text-2xl">
                          Quick{" "}
                          <span style={{ color: "#557a82" }}>Application</span>
                        </h1>
                      )}
                      {modalId === 5 && (
                        <h1 className="text-2xl">
                          Quick Book Your{" "}
                          <span style={{ color: "#557a82" }}>Computer</span>
                        </h1>
                      )}
                      {modalId === 6 && (
                        <h1 className="text-2xl">
                          Quick{" "}
                          <span style={{ color: "#557a82" }}>Typed</span>
                        </h1>
                      )}
                      <div className="ml-auto">
                        <CloseSquareOutlined
                          className="text-xl text-customBlue hover:text-cardFieldNormalbg"
                          onClick={onClose}
                        />
                      </div>
                    </div>
                  </DialogTitle>

                  {/* Form Submission */}
                  <div className="">
                    {submitted ? (
                      <div className="text-center px-6 py-10  bg-transparent">
                        <h3 className="text-2xl text-customBlue">
                          Thank you for choosing <br /> <span style={{ color: "#557a82" }}>Grand Shop Rwanda Ltd!</span> 
                        </h3>
                        <p>
                          {" "}
                          A representative will contact you within 24 hours.
                        </p>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit}>
                        <label htmlFor="name" className="text-start">
                          Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          placeholder="Your Name"
                          required
                          className="bg-cardFieldNormalbg mb-2 focus:bg-cardFieldFocusbg py-2 px-8 w-full text-textColor mt-4"
                          value={formData.name}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="tel" className="text-start">
                          Tel
                        </label>
                        <input
                          type="number"
                          name="tel"
                          placeholder="+250788888888"
                          required
                          className="bg-cardFieldNormalbg mb-2 focus:bg-cardFieldFocusbg py-2 px-8 w-full text-textColor mt-4"
                          value={formData.tel}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="email" className="text-start">
                          Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          placeholder="example@gmail.com"
                          required
                          className="bg-cardFieldNormalbg mb-2 focus:bg-cardFieldFocusbg py-2 px-8 w-full text-textColor mt-4"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="order" className="text-start">
                          Name and brief about order
                        </label>
                        <textarea
                          name="order"
                          id="order"
                          placeholder="Tell us few about the order..."
                          required
                          className="bg-cardFieldNormalbg mb-2 focus:bg-cardFieldFocusbg w-full py-8 px-8 text-textColor mt-4"
                          value={formData.order}
                          onChange={handleInputChange}
                        ></textarea>

                        <div className="flex justify-end mt-4">
                          <button
                            type="submit"
                            className="text-white px-6 py-3 shadow-md bg-[#557a82] hover:text-customBlue hover:bg-white transition"
                          >
                            {loading ? "Submitting..." : "Submit Order"}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
